import React, { FC } from 'react';
import classnames from 'classnames';
import { PresenterTabsOnMobile } from '../../../constans/presenter-enums';

interface IProps {
    additionalTabText?: string;
    selectedTab: PresenterTabsOnMobile;
    tabName: PresenterTabsOnMobile;
    setSelectedTab: (tabName: PresenterTabsOnMobile) => void;
}

const PresenterMobileNavigationTab: FC<IProps> = ({
  selectedTab,
  setSelectedTab,
  tabName,
  additionalTabText
}): JSX.Element => {

  const handleSelectTab = (): void => setSelectedTab(tabName);

  return (
    <div
      className={classnames('presenter-mobile-navigation__tab', { 'active': tabName === selectedTab })}
      onClick={handleSelectTab}
    >
      {tabName} {additionalTabText ?? ''}
    </div>
  );
};

export default PresenterMobileNavigationTab;

